import React from "react";
import { Box, Button, Modal } from "@mui/material";
import { useModalContext } from "../ModalContext";

function AlertModal({
  alertModalOpen,
  message,
  alertModelClose,
  handleCancelScheme,
  handleCancelClick,
}) {
  const { setAlertModalOpen } = useModalContext();

  return (
    <>
      <Modal open={alertModalOpen}>
        <Box
          sx={{
            bgcolor: "background.paper",
            maxWidth: 800,
            maxHeight: "80vh",
            overflowY: "auto",
            mx: "auto",
            marginTop: "80px",
          }}
        >
          <Box
            sx={{
              p: "22px",
              color: "#fff",
              backgroundColor: "#16a695",
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            <h2
              style={{
                fontWeight: "500",
                fontSize: "1.25rem",
                lineHeight: "1.6",
                margin: "0",
              }}
            >
              Alert
            </h2>
          </Box>
          <Box
            sx={{
              p: 4,
            }}
          >
            {message}
          </Box>
          <Box
            sx={{
              p: 4,
            }}
          >
            <Box sx={{ mt: 3, textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  alertModelClose();
                  handleCancelClick(true);
                }}
                style={{
                  backgroundColor: "#16a695",
                  color: "white",
                }}
              >
                Yes
              </Button>
              &nbsp;&nbsp;&nbsp;
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  alertModelClose();
                }}
                style={{
                  backgroundColor: "#fff",
                  borderColor: "#16a695",
                  color: "#16a695",
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default AlertModal;
